// Runtime environment validation
const validateEnvironment = (environment: string | undefined): "local" | "production" | "staging" => {
  const validEnvironments = ["local", "production", "staging"] as const;

  if (!environment) {
    throw new Error("VITE_ENVIRONMENT is not defined. Must be one of: local, production, staging");
  }

  if (!validEnvironments.includes(environment as "local" | "production" | "staging")) {
    throw new Error(`Invalid VITE_ENVIRONMENT: "${environment}". Must be one of: ${validEnvironments.join(", ")}`);
  }

  return environment as "local" | "production" | "staging";
};

const constants = {
  APP_VERSION: import.meta.env.VITE_APP_VERSION,
  AUTH_TOKEN_KEY: "authToken",
  ENVIRONMENT: validateEnvironment(import.meta.env.VITE_ENVIRONMENT),
  LOOM_CAMPAIGNS:
    "https://www.loom.com/share/7f0862ec77f04be48191025eac058263?sid=474ee27d-6094-4816-b2c8-b2283ef55ba6",
  LOOM_CONTACTS: "https://www.loom.com/share/c4527f88efa840b0bf48e372b0e4ce4e?sid=f7c1eec0-380f-4427-b822-c7a0926597e9",
  LOOM_DATA_RESOURCES_EMBED:
    "https://www.loom.com/embed/e0947bdfa91b41179932ee87e58d57b1?sid=a8c9ccf4-de3c-4f74-89fd-5aadfe8e4ed1",
  LOOM_DATA_RESOURCES_SHARE:
    "https://www.loom.com/share/ddd52eccd76642128e759de7963e3099?sid=31d301b6-568c-4f59-9978-1622d1b01d54",
  LOOM_IP_SEARCH:
    "https://www.loom.com/share/f2b6bd6df22349ceab386f70bacd45d1?sid=e3b609c5-6016-40ca-a1c1-87c32f0a3b7c",
  LOOM_TEMPLATES:
    "https://www.loom.com/embed/5159b3fb2a69468184109c7e842fb6fc?sid=e5906bef-96eb-4e4d-a0a5-5fc5856b045c",
  MAX_REQUEST_BODY_SIZE_KB: 7.5, // leave .5 KB to avoid running right up against the 8 KB AWS WAF limit
  NYLAS_PERMISSIONS_GOOGLE: [
    "openid",
    "https://www.googleapis.com/auth/userinfo.email",
    "https://www.googleapis.com/auth/userinfo.profile",
    "https://www.googleapis.com/auth/gmail.send",
    "https://www.googleapis.com/auth/gmail.readonly",
  ],
  NYLAS_PERMISSIONS_MICROSOFT: [
    "User.Read",
    "offline_access",
    "openid",
    "email",
    "profile",
    "Mail.ReadWrite",
    "Mail.Send",
  ],
  REDIRECT_KEY: "redirect",
  SCORE_DECIMAL_PLACES: 1,
  SENTRY_ENABLED_ENVIRONMENTS: ["production", "staging"] as ("local" | "production" | "staging")[],
  SMART_SEARCH: "isSmartSearchEnabled",
  // 24 hours in milliseconds
  STALE_TIME: 86_400_000,
  USER_KEY: "user",
  VITE_APP_APP: import.meta.env.VITE_APP_APP,
  VITE_APP_EXPRESS_SERVER: import.meta.env.VITE_APP_EXPRESS_SERVER,
  VITE_APP_MUI_LICENSE_KEY: import.meta.env.VITE_APP_MUI_LICENSE_KEY,
  VITE_APP_NEST_SERVER: import.meta.env.VITE_APP_NEST_SERVER,
  VITE_APP_WEBSITE: import.meta.env.VITE_APP_WEBSITE,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_ORG: import.meta.env.VITE_SENTRY_ORG,
  VITE_SENTRY_PROJECT: import.meta.env.VITE_SENTRY_PROJECT,
} as const;

export default constants;
